import { render } from "./FlagFrench.vue?vue&type=template&id=6718665e&ts=true"
import script from "./FlagFrench.vue?vue&type=script&lang=ts"
export * from "./FlagFrench.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paul/Documents/JetBrains/PhpstormProjects/AzuriomInstaller/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__